import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import Layout from '../components/Layout'
import Content, { HTMLContent } from '../components/Content'

export const VideoPageTemplate = ({ title, content, contentComponent, videos }) => {
  const PageContent = contentComponent || Content

  const videosContent = videos.map((r, index) => {
    return(
      <div key={index} className="video column is-4">
        <h3>{r.name}</h3>
        <HTMLContent className="video__embed-code" content={r.embed_code} />
        <HTMLContent className="video__description" content={r.description} />
      </div>
    )
  })

  return (
    <div className="container">
      <div className="columns">
        <div className="column is-10 is-offset-1">
          <div className="section">
            <h2 className="title is-bold-light">
              {title}
            </h2>
            <PageContent className="content" content={content} />
            <div className="columns is-multiline">
              {videosContent}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

VideoPageTemplate.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string,
  contentComponent: PropTypes.func,
  videos: PropTypes.array
}

const VideoPage = ({ data }) => {
  const { markdownRemark: post } = data

  return (
    <Layout>
      <VideoPageTemplate
        contentComponent={HTMLContent}
        title={post.frontmatter.title}
        content={post.html}
        videos={post.frontmatter.videos}
      />
    </Layout>
  )
}

VideoPage.propTypes = {
  data: PropTypes.object.isRequired,
}

export default VideoPage

export const musicPageQuery = graphql`
  query VideoPage($id: String!) {
    markdownRemark(id: { eq: $id }) {
      html
      frontmatter {
        title
        videos {
          name
          embed_code
          description
        }
      }
    }
  }
`
